import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-3 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "card mb-3 border-0 rounded-0 bg-white"
}
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "row mb-3" }
const _hoisted_9 = {
  key: 0,
  class: "col-md-3 d-flex align-items-center mb-2 mb-md-0"
}
const _hoisted_10 = { class: "col-md-9" }
const _hoisted_11 = { class: "d-flex justify-content-end" }
const _hoisted_12 = { class: "form-group mb-0" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 4 }
const _hoisted_18 = { class: "row mt-3" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "card mb-3 border-0 rounded-0 bg-white" }
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = { class: "row mb-3" }
const _hoisted_23 = {
  key: 0,
  class: "col-md-3 d-flex align-items-center mb-2 mb-md-0"
}
const _hoisted_24 = { class: "col-md-9" }
const _hoisted_25 = { class: "d-flex justify-content-end" }
const _hoisted_26 = { class: "form-group mb-0" }
const _hoisted_27 = { class: "d-flex align-items-center" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_30 = { key: 3 }
const _hoisted_31 = { key: 4 }
const _hoisted_32 = { class: "row mt-3" }
const _hoisted_33 = { class: "col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.paymentZone.pay_z_ref), 1),
        _createElementVNode("h5", _hoisted_4, [
          _cache[10] || (_cache[10] = _createTextVNode(" Date de création : ", -1)),
          (_ctx.paymentZone.created_at)
            ? (_openBlock(), _createElementBlock("b", _hoisted_5, _toDisplayString(_ctx.getDate(_ctx.paymentZone.created_at)), 1))
            : _createCommentVNode("", true),
          _cache[11] || (_cache[11] = _createTextVNode(" | Zone: ", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.paymentZone.zone_name), 1)
        ])
      ])
    ]),
    (_ctx.paymentZone.statut == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", { class: "mb-0" }, "Nouveaux Bons")
          ], -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_ctx.auth.can('ADD_BP_Z'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_ctx.paymentZone.statut == 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-success",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.AddNewColis && _ctx.AddNewColis(...args)))
                        }, " Ajouter "))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.users1.per_page,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.users1.per_page) = $event)),
                      options: [10, 50],
                      clearable: false,
                      class: "me-2",
                      onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getRows1()))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.users1.total) + " entités", 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        placeholder: "Chercher",
                        type: "text",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.users1.searchTerm) = $event)),
                        onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getRows1())),
                        class: "form-control"
                      }, null, 544), [
                        [_vModelText, _ctx.users1.searchTerm]
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode(_component_vue_good_table, {
              columns: _ctx.columns,
              rows: _ctx.rows1,
              "select-options": {
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        },
              onSelectAll: _ctx.onSelectAll,
              onSelectedRowsChange: _ctx.selectionChanged,
              responsive: "",
              "search-options": {
          enabled: true,
          externalQuery: _ctx.users1.searchTerm,
        }
            }, {
              emptystate: _withCtx(() => _cache[12] || (_cache[12] = [
                _createElementVNode("div", { class: "text-center" }, "Aucune entrées correspondants trouvés", -1)
              ])),
              "table-row": _withCtx((props) => [
                (props.column.field === 'note_ref')
                  ? (_openBlock(), _createElementBlock("b", _hoisted_14, _toDisplayString(props.row.note_ref), 1))
                  : (props.column.field === 'total')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("b", null, _toDisplayString(props.row.total), 1),
                        _cache[13] || (_cache[13] = _createTextVNode(" DH ", -1))
                      ], 64))
                    : (props.column.field === 'created_at')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          (props.row.created_at)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (props.column.field === 'zone_name')
                        ? (_openBlock(), _createElementBlock("b", _hoisted_16, _toDisplayString(props.row.zone_name), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(props.formattedRow[props.column.field]), 1))
              ]),
              _: 1
            }, 8, ["columns", "rows", "onSelectAll", "onSelectedRowsChange", "search-options"]),
            _createElementVNode("div", _hoisted_18, [
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col-md-6" }, null, -1)),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_PaginatorContent, {
                  pagination: _ctx.users1,
                  offset: 9,
                  onPaginate: _ctx.getRows1
                }, null, 8, ["pagination", "onPaginate"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h3", { class: "mb-0" }, "Bons Ajoutés")
      ], -1)),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          (_ctx.auth.can('ADD_BP_Z'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                (_ctx.paymentZone.statut == 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-danger",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.RemoveNewColis && _ctx.RemoveNewColis(...args)))
                    }, " Supprimer "))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_select, {
                  modelValue: _ctx.users2.per_page,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.users2.per_page) = $event)),
                  options: [10, 50],
                  clearable: false,
                  class: "me-2",
                  onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getRows2()))
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", null, _toDisplayString(_ctx.users2.total) + " entités", 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _withDirectives(_createElementVNode("input", {
                    placeholder: "Chercher",
                    type: "text",
                    onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getRows2())),
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.users2.searchTerm) = $event)),
                    class: "form-control"
                  }, null, 544), [
                    [_vModelText, _ctx.users2.searchTerm]
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows2,
          "select-options": {
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        },
          onSelectAll: _ctx.onSelectAllColis,
          onSelectedRowsChange: _ctx.selectionChangedColis,
          responsive: "",
          "search-options": {
          enabled: true,
          externalQuery: _ctx.users2.searchTerm,
        }
        }, {
          emptystate: _withCtx(() => _cache[16] || (_cache[16] = [
            _createElementVNode("div", { class: "text-center" }, "Aucune entrées correspondants trouvés", -1)
          ])),
          "table-row": _withCtx((props) => [
            (props.column.field === 'note_ref')
              ? (_openBlock(), _createElementBlock("b", _hoisted_28, _toDisplayString(props.row.note_ref), 1))
              : (props.column.field === 'total')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("b", null, _toDisplayString(props.row.total), 1),
                    _cache[17] || (_cache[17] = _createTextVNode(" DH ", -1))
                  ], 64))
                : (props.column.field === 'created_at')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (props.row.created_at)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (props.column.field === 'zone_name')
                    ? (_openBlock(), _createElementBlock("b", _hoisted_30, _toDisplayString(props.row.zone_name), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "onSelectAll", "onSelectedRowsChange", "search-options"]),
        _createElementVNode("div", _hoisted_32, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "col-md-6" }, null, -1)),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_PaginatorContent, {
              pagination: _ctx.users2,
              offset: 9,
              onPaginate: _ctx.getRows2
            }, null, 8, ["pagination", "onPaginate"])
          ])
        ])
      ])
    ])
  ], 64))
}